import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAlignVerticalCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.75 4.75h14.5M4.75 19.25h14.5M6.75 13.25v-2.5a2 2 0 0 1 2-2h6.5a2 2 0 0 1 2 2v2.5a2 2 0 0 1-2 2h-6.5a2 2 0 0 1-2-2"
    />
  </svg>
);
export default SvgAlignVerticalCenter;
